const competition1 = [
    /**level 1: base, suma resta sencillas **/
    {
        level: 1,
        label: 'paper',
        open: true,
        units: [
            {
                uid: 1,
                label: 'numbers1to10',//'El ábaco japonés',
                icon: 'levels/1_cifra.png',
            },

            {
                uid: 2,
                label: 'easysumsandsubs',//'Representación de números',
                icon: 'levels/sumas_y_restas.png',
            },

            {
                uid: 3,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'heart',
                        params: { couples: 'random', init: 0, finish: 9, rows: 1, valueinabacus: 0, coins: 10, num: 4, errors: 0 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: { couples: ['2+2', '2+5', '2+6', '2+7', '3+5', '3+6', '4+5', '5+2', '5+3', '5+4', '6+2', '6+3', '7+2', '4-2', '4-3', '6-5', '7-2', '7-5', '7-6', '8-2', '8-3', '8-5', '8-6', '8-7', '9-2', '9-3', '9-4', '9-5', '9-6', '9-7', '9-8'], init: 1, finish: 9, rows: 1, valueinabacus: 0, coins: 10, num: 0, errors: 0, levels: [{ num: 2, vel: 20 }, { num: 4, vel: 20 }, { num: 8, vel: 20 }, { num: 6, vel: 10 }, { num: 8, vel: 10 }] }
                    },
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['2+7', '3+6', '4+5', '5+4', '6+1', '6+2', '6+3', '7+1', '7+2', '8+1', '7+2', '1+8', '1+1+2', '1+3+5', '1+5+2', '1+6+1', '2+2+5', '2+6+1', '3+1+5'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0 }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['9-2', '9-4', '9-5', '9-7', '9-8', '8-1', '8-2', '8-3', '8-5', '8-7', '8-6', '7-2', '7-5', '7-6', '6-1', '6-5', '4-1', '4-2', '4-3', '3-1', '3-2', '9-6-1', '9-1-7'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 2: suma y resta 5 **/
    {
        level: 2,
        label: 'wood',
        open: true,
        units: [
            {
                uid: 4,
                label: 'sumswith5',//Sumas y restas sencillas,
                level: 2,
                icon: 'levels/sumas_5.png',
            },

            {
                uid: 5,
                label: 'subswith5',//Sumas y restas sencillas,
                level: 2,
                icon: 'levels/restas_5.png',
            },

            {
                uid: 6,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 2,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['1+4', '2+3', '2+4', '3+2', '3+3', '3+4', '4+1'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['5-1', '5-2', '6-2', '5-3', '6-3', '7-3', '5-4', '6-4', '7-4', '8-4'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 3: decenas y suma resta 10 **/
    {
        level: 3,
        label: 'iron',
        open: true,
        units: [
            {
                uid: 7,
                label: 'numberstill99',//Sumar y restar con el 10,
                level: 3,
                icon: 'levels/numeros_2_cifras.png',
            },

            {
                uid: 8,
                label: 'sumswith10',
                level: 3,
                icon: 'levels/sumas_10.png',
            },


            {
                uid: 9,
                label: 'subswith10',
                level: 3,
                icon: 'levels/restas_10.png',
            },

            {
                uid: 10,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 3,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'relaciona',
                        params: { couples: 'random', init: 10, finish: 99, rows: 2, valueinabacus: 0, coins: 10, num: 4, errors: 0 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: { couples: ['8+6', '7+7', '7+6', '6+6', '6+7', '6+8', '5+6', '5+7', '5+8', '5+9', '9+3', '9+4', '9+5', '9+6', '9+7', '9+8', '9+9', '8+2', '8+3', '8+4', '8+5', '8+7', '8+8', '8+9', '7+9', '7+3', '7+4', '7+5', '6+9', '6+5', '6+4', '5+5', '4+9', '4+8', '4+7', '4+6', '3+9', '3+8', '3+7', '2+8', '2+9', '1+9', '8+6', '7+7', '7+6', '6+6', '6+7', '6+8', '5+6', '5+7', '5+8', '5+9', '11-6', '12-6', '12-7', '13-6', '13-7', '13-8', '14-6', '14-7', '14-8', '14-9', '10-1', '10-2', '10-3', '10-4', '10-5', '10-6', '10-7', '10-8', '10-9', '11-2', '11-3', '11-4', '11-5', '11-7', '11-8', '11-9', '12-3', '12-4', '12-5', '13-4', '13-5', '13-9', '14-5', '15-6', '15-7', '15-8', '15-9', '16-7', '16-8', '16-9', '17-8', '17-9', '18-9', '11-6', '12-6', '12-7', '13-6', '13-7', '13-8', '14-6', '14-7', '14-8', '14-9'], init: 10, finish: 99, rows: 2, valueinabacus: 0, coins: 10, num: 1, errors: 0, levels: [{ num: 4, vel: 15 }, { num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 10 }, { num: 12, vel: 10 }] }
                    },
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['+'], init: 30, finish: 60, ispan: 1, fspan: 9, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 2, num: 5 }], wait: 3, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['-'], init: 30, finish: 60, ispan: 1, fspan: 9, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 2, num: 5 }], wait: 3, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 4: centenas y suma resta 2c **/
    {
        level: 4,
        label: 'clay',
        open: true,
        units: [
            {
                uid: 11,
                label: 'numberstill999',//Sumar y restar con el 10,
                level: 4,
                icon: 'levels/numeros_3_cifras.png',
            },

            {
                uid: 12,
                label: 'sumsandsubswith2',
                level: 4,
                icon: 'levels/sumas_y_restas_2_cifras.png',
            },

            {
                uid: 13,
                label: 'strengthenlearnt',//practicar
                level: 4,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'relaciona',
                        params: { couples: 'random', init: 10, finish: 99, rows: 2, valueinabacus: 0, coins: 10, num: 4, errors: 0, style: 'small', 'flipbacktime': 2000 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['-', '+'], 'numops': 2, init: 30, finish: 60, ispan: 11, fspan: 29, rows: 2, valueinabacus: 0, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'pathchall',//El reto del camino,
                        impl: 'pathchall',
                        icon: 'path',
                        params: { couples: 'random', init: 2, finish: 6, op: '+', ispan: 11, fspan: 19, items: 5, num: 2, cols: 6, coins: 10, errors: 0 }
                    },
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['+'], init: 11, finish: 29, ispan: 11, fspan: 29, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 2, num: 3 }, { digits: 1, num: 3 }], wait: 4, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['-'], init: 71, finish: 99, ispan: 11, fspan: 19, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 2, num: 3 }, { digits: 1, num: 3 }], wait: 4, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 5: suma resta 3c **/
    {
        level: 5,
        label: 'bronze',
        open: true,
        units: [
            {
                uid: 14,
                label: 'sumsandsubswith3',
                level: 5,
                icon: 'levels/sumas_y_restas_3_cifras.png',
            },

            {
                uid: 15,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 5,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'heart',
                        params: { couples: 'random', init: 100, finish: 999, rows: 3, valueinabacus: 0, coins: 10, num: 4, errors: 0, style: 'small', 'flipbacktime': 2000 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['-', '+'], 'numops': 2, init: 300, finish: 600, ispan: 111, fspan: 299, rows: 3, valueinabacus: 0, 'upperlimit': 999, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'pathchall',//El reto del camino,
                        impl: 'pathchall',
                        icon: 'path',
                        params: { couples: 'random', init: 20, finish: 60, op: '+', ispan: 101, fspan: 199, num: 2, items: 7, cols: 4, coins: 10, errors: 0 }
                    },
                    {
                        label: 'mentalsumchall',
                        icon: 'mental',
                        impl: 'mentalsumsubstraction',
                        params: { couples: 'random', ops: ['+'], init: 111, finish: 299, ispan: 111, fspan: 199, valueinabacus: 0, rows: 3, coins: 10, num: 1, config: [{ digits: 3, num: 3 }, { digits: 2, num: 2 }, { digits: 1, num: 2 }], wait: 5, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['-'], init: 711, finish: 999, ispan: 111, fspan: 199, valueinabacus: 0, rows: 3, coins: 10, num: 1, config: [{ digits: 3, num: 3 }, { digits: 2, num: 2 }, { digits: 1, num: 2 }], wait: 5, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**challenges **/
    {
        level: 'challenges',
        label: 'challenges',
        open: true,
        units: [
            {
                uid: 'ch1',
                label: 'strengthenlearnt',
                level: 6,
                icon: 'challenge/numriddle.png',
                exercises: [
                    {
                        label: 'findvalue',
                        impl: 'numberriddle',
                        icon: 'easys',
                        params: { coins: 20, num: 1, errors: 0, timeout: 30, init: 2, finish: 9, permOps: ['+', '-'] }
                    },
                    {
                        label: 'completeoperations',
                        impl: 'completeoperations',
                        icon: 'easys',
                        params: { ops: 2, permOps: ['+', '-'], init: 21, finish: 399, coins: 20, num: 1, errors: 0, timeout: 30 }
                    },
                    {
                        label: 'challengevisualmem',
                        impl: 'memomeshchallenge',
                        icon: 'easys',
                        params: { num_objects: 4, wait: 10, coins: 40, num: 1, errors: 0, timeout: 60, rows: 3 }
                    },
                    {
                        label: 'findpath',
                        impl: 'numericpath',
                        icon: 'easys',
                        params: { ispan: 1, fspan: 19, num: 1, items: 7, cols: 4, timeout: 120, rows: 3, coins: 50, errors: 0 }
                    },
                    {
                        label: 'solveequation',
                        impl: 'equationchallenge',
                        icon: 'easys',
                        params: { ops: 4, permOps: ['+', '-'], init: 21, finish: 199, num: 1, timeout: 30, rows: 3, coins: 60, errors: 0 }
                    },
                ]
            },

        ],
    }
];


const competition2 = [
    /**level 1: base, suma resta sencillas **/
    {
        level: 1,
        label: 'paper',
        open: true,
        units: [
            {
                uid: 1,
                label: 'numbers1_2_3_figs',//'El ábaco japonés',
                icon: 'levels/numeros_1_2_3_cifras.png',
            },

            {
                uid: 2,
                label: 'easysumsandsubs',//'Representación de números',
                icon: 'levels/sumas_y_restas.png',
            },

            {
                uid: 3,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'heart',
                        params: { series: [{ init: 0, finish: 9, num: 4 }, { init: 10, finish: 99, num: 4 }, { init: 100, finish: 999, num: 4 }], couples: 'random', init: 0, finish: 9, rows: 3, valueinabacus: 0, coins: 10, num: 4, errors: 0 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: { couples: ['2+2', '2+5', '2+6', '2+7', '3+5', '3+6', '4+5', '5+2', '5+3', '5+4', '6+2', '6+3', '7+2', '4-2', '4-3', '6-5', '7-2', '7-5', '7-6', '8-2', '8-3', '8-5', '8-6', '8-7', '9-2', '9-3', '9-4', '9-5', '9-6', '9-7', '9-8'], init: 1, finish: 9, rows: 1, valueinabacus: 0, coins: 10, num: 0, errors: 0, levels: [{ num: 2, vel: 20 }, { num: 4, vel: 20 }, { num: 8, vel: 20 }, { num: 6, vel: 10 }, { num: 8, vel: 10 }] }
                    },
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['2+7', '3+6', '4+5', '5+4', '6+1', '6+2', '6+3', '7+1', '7+2', '8+1', '7+2', '1+8', '1+1+2', '1+3+5', '1+5+2', '1+6+1', '2+2+5', '2+6+1', '3+1+5'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0 }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['9-2', '9-4', '9-5', '9-7', '9-8', '8-1', '8-2', '8-3', '8-5', '8-7', '8-6', '7-2', '7-5', '7-6', '6-1', '6-5', '4-1', '4-2', '4-3', '3-1', '3-2', '9-6-1', '9-1-7'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 2: suma y resta 5 **/
    {
        level: 2,
        label: 'wood',
        open: true,
        units: [
            {
                uid: 4,
                label: 'sumswith5',//Sumas y restas sencillas,
                level: 2,
                icon: 'levels/sumas_5.png',
            },

            {
                uid: 5,
                label: 'subswith5',//Sumas y restas sencillas,
                level: 2,
                icon: 'levels/restas_5.png',
            },

            {
                uid: 6,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 2,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['1+4', '2+3', '2+4', '3+2', '3+3', '3+4', '4+1'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['5-1', '5-2', '6-2', '5-3', '6-3', '7-3', '5-4', '6-4', '7-4', '8-4'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 3: suma y resta 10 **/
    {
        level: 3,
        label: 'iron',
        open: true,
        units: [
            {
                uid: 8,
                label: 'sumswith10',
                level: 3,
                icon: 'levels/sumas_10.png',
            },


            {
                uid: 9,
                label: 'subswith10',
                level: 3,
                icon: 'levels/restas_10.png',
            },

            {
                uid: 10,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 3,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'relaciona',
                        params: { couples: 'random', init: 10, finish: 99, rows: 2, valueinabacus: 0, coins: 10, num: 4, errors: 0 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: { couples: ['8+6', '7+7', '7+6', '6+6', '6+7', '6+8', '5+6', '5+7', '5+8', '5+9', '9+3', '9+4', '9+5', '9+6', '9+7', '9+8', '9+9', '8+2', '8+3', '8+4', '8+5', '8+7', '8+8', '8+9', '7+9', '7+3', '7+4', '7+5', '6+9', '6+5', '6+4', '5+5', '4+9', '4+8', '4+7', '4+6', '3+9', '3+8', '3+7', '2+8', '2+9', '1+9', '8+6', '7+7', '7+6', '6+6', '6+7', '6+8', '5+6', '5+7', '5+8', '5+9', '11-6', '12-6', '12-7', '13-6', '13-7', '13-8', '14-6', '14-7', '14-8', '14-9', '10-1', '10-2', '10-3', '10-4', '10-5', '10-6', '10-7', '10-8', '10-9', '11-2', '11-3', '11-4', '11-5', '11-7', '11-8', '11-9', '12-3', '12-4', '12-5', '13-4', '13-5', '13-9', '14-5', '15-6', '15-7', '15-8', '15-9', '16-7', '16-8', '16-9', '17-8', '17-9', '18-9', '11-6', '12-6', '12-7', '13-6', '13-7', '13-8', '14-6', '14-7', '14-8', '14-9'], init: 10, finish: 99, rows: 2, valueinabacus: 0, coins: 10, num: 1, errors: 0, levels: [{ num: 4, vel: 15 }, { num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 10 }, { num: 12, vel: 10 }] }
                    },
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['+'], init: 1, finish: 9, ispan: 1, fspan: 9, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 1, num: 3 }], wait: 3, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['-'], init: 11, finish: 19, ispan: 1, fspan: 9, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 1, num: 3 }], wait: 3, errors: 0, cansubstract: true }
                    },

                ]
            },
        ],
        
    },

    /**level 4: suma y resta 2c **/
    {
        level: 4,
        label: 'clay',
        open: true,
        units: [

            {
                uid: 12,
                label: 'sumsandsubswith2',
                level: 4,
                icon: 'levels/sumas_y_restas_2_cifras.png',
            },

            {
                uid: 13,
                label: 'strengthenlearnt',//practicar
                level: 4,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'relaciona',
                        params: { couples: 'random', init: 10, finish: 99, rows: 2, valueinabacus: 0, coins: 10, num: 4, errors: 0, style: 'small', 'flipbacktime': 2000 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['-', '+'], 'numops': 2, init: 30, finish: 60, ispan: 11, fspan: 29, rows: 2, valueinabacus: 0, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'pathchall',//El reto del camino,
                        impl: 'pathchall',
                        icon: 'path',
                        params: { couples: 'random', init: 2, finish: 6, op: '+', ispan: 11, fspan: 19, items: 5, num: 2, cols: 6, coins: 10, errors: 0 }
                    },
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['+'], init: 11, finish: 29, ispan: 11, fspan: 29, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 2, num: 3 }, { digits: 1, num: 3 }], wait: 4, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['-'], init: 71, finish: 99, ispan: 11, fspan: 19, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 2, num: 3 }, { digits: 1, num: 3 }], wait: 4, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 5: suma y resta 3c **/
    {
        level: 5,
        label: 'bronze',
        open: true,
        units: [
            {
                uid: 14,
                label: 'sumsandsubswith3',
                level: 5,
                icon: 'levels/sumas_y_restas_3_cifras.png',
            },

            {
                uid: 15,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 5,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'heart',
                        params: { couples: 'random', init: 100, finish: 999, rows: 3, valueinabacus: 0, coins: 10, num: 4, errors: 0, style: 'small', 'flipbacktime': 2000 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['-', '+'], 'numops': 2, init: 300, finish: 600, ispan: 111, fspan: 299, rows: 3, valueinabacus: 0, 'upperlimit': 999, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'pathchall',//El reto del camino,
                        impl: 'pathchall',
                        icon: 'path',
                        params: { couples: 'random', init: 20, finish: 60, op: '+', ispan: 101, fspan: 199, num: 2, items: 7, cols: 4, coins: 10, errors: 0 }
                    },
                    {
                        label: 'mentalsumchall',
                        icon: 'mental',
                        impl: 'mentalsumsubstraction',
                        params: { couples: 'random', ops: ['+'], init: 111, finish: 299, ispan: 111, fspan: 199, valueinabacus: 0, rows: 3, coins: 10, num: 1, config: [{ digits: 3, num: 3 }, { digits: 2, num: 2 }, { digits: 1, num: 2 }], wait: 5, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['-'], init: 711, finish: 999, ispan: 111, fspan: 199, valueinabacus: 0, rows: 3, coins: 10, num: 1, config: [{ digits: 3, num: 3 }, { digits: 2, num: 2 }, { digits: 1, num: 2 }], wait: 5, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 6: multiplicaciones 1c **/
    {
        level: 6,
        label: 'ivory',
        open: true,
        units: [
            {
                uid: 17,
                label: 'multi1',
                level: 7,
                icon: 'levels/multiplicaciones_1_cifra.png',
            },

            {
                uid: 18,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 7,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'challmultI',//Practica con el ábaco,
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['*'], only_answer: true, init: 11, finish: 99, ispan: 2, fspan: 9, rows: 3, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'challmultII',//Practica con el ábaco,
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['*'], only_answer: true, init: 111, finish: 999, ispan: 2, fspan: 9, rows: 4, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'baloonschallI',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['*'], 'numops': 2, init: 11, finish: 99, ispan: 2, fspan: 9, rows: 3, valueinabacus: 0, 'upperlimit': 9 * 99, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }

                    },
                    {
                        label: 'baloonschallII',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['*'], 'numops': 2, init: 111, finish: 999, ispan: 2, fspan: 9, rows: 4, valueinabacus: 0, 'upperlimit': 999 * 9, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                ]
            },
        ],
        
    },

    /**level 7: divisiones 1c **/
    {
        level: 7,
        label: 'glass',
        open: true,
        units: [
            {
                uid: 19,
                label: 'divi1',
                level: 8,
                icon: 'levels/divisiones_1_cifra.png',
            },

            {
                uid: 20,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 8,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'challdivI',
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['/'], only_answer: true, init: 11, finish: 99, ispan: 2, fspan: 9, rows: 2, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'challdivII',
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['/'], only_answer: true, init: 111, finish: 999, ispan: 2, fspan: 9, rows: 3, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'baloonschallI',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['/'], 'numops': 2, init: 11, finish: 99, ispan: 2, fspan: 9, rows: 2, valueinabacus: 0, 'upperlimit': 99 / 9, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'baloonschallII',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['/'], 'numops': 2, init: 111, finish: 999, ispan: 2, fspan: 9, rows: 3, valueinabacus: 0, 'upperlimit': 999 / 9, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                ]
            },
        ],
        
    },

    /**level 8: suma y resta 4c **/
    {
        level: 8,
        label: 'steel',
        open: true,
        units: [
            {
                uid: 21,
                label: 'sumsandsubswith4',
                level: 6,
                icon: 'levels/sumas_y_restas_4_cifras.png',
            },

            {
                uid: 24,
                label: 'strengthenlearnt',
                level: 6,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['-', '+'], 'numops': 2, init: 3000, finish: 6000, ispan: 111, fspan: 2999, rows: 4, valueinabacus: 0, 'upperlimit': 9999, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'pathchall',//El reto del camino,
                        impl: 'pathchall',
                        icon: 'path',
                        params: { couples: 'random', init: 200, finish: 600, op: '+', ispan: 1001, fspan: 1999, num: 2, items: 7, cols: 4, coins: 10, errors: 0 }
                    },
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['+'], init: 1111, finish: 2999, ispan: 1111, fspan: 1999, valueinabacus: 0, rows: 4, coins: 10, num: 1, config: [{ digits: 4, num: 3 }, { digits: 3, num: 2 }, { digits: 2, num: 2 }], wait: 6, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['-'], init: 7111, finish: 9999, ispan: 1111, fspan: 1999, valueinabacus: 0, rows: 4, coins: 10, num: 1, config: [{ digits: 4, num: 3 }, { digits: 3, num: 2 }, { digits: 2, num: 2 }], wait: 6, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**challenges **/
    {
        level: 'challenges',
        label: 'challenges',
        open: true,
        units: [
            {
                uid: 'ch1',
                label: 'strengthenlearnt',
                level: 9,
                icon: 'challenge/numriddle.png',
                exercises: [
                    {
                        label: 'findvalue',
                        impl: 'numberriddle',
                        icon: 'easys',
                        params: { coins: 20, num: 1, errors: 0, timeout: 30, init: 2, finish: 9 }
                    },
                    {
                        label: 'completeoperations',
                        impl: 'completeoperations',
                        icon: 'easys',
                        params: { ops: 2, coins: 20, num: 1, errors: 0, timeout: 30 }
                    },
                    {
                        label: 'challengevisualmem',
                        impl: 'memomeshchallenge',
                        icon: 'easys',
                        params: { num_objects: 5, wait: 10, coins: 40, num: 1, errors: 0, timeout: 60, rows: 3 }
                    },
                    {
                        label: 'findpath',
                        impl: 'numericpath',
                        icon: 'easys',
                        params: { ispan: 1, fspan: 29, num: 1, items: 7, cols: 4, timeout: 120, rows: 3, coins: 50, errors: 0 }
                    },
                    {
                        label: 'solveequation',
                        impl: 'equationchallenge',
                        icon: 'easys',
                        params: { ops: 5, init: 11, finish: 59, num: 1, timeout: 30, rows: 3, coins: 60, errors: 0 }
                    },
                ]
            },

        ],
    }
];


const competition3 = [
    /**level 1: base, suma resta sencillas **/
    {
        level: 1,
        label: 'paper',
        open: true,
        units: [
            {
                uid: 1,
                label: 'numbers1_2_3_figs',//'El ábaco japonés',
                icon: 'levels/numeros_1_2_3_cifras.png',
            },

            {
                uid: 2,
                label: 'easysumsandsubs',//'Representación de números',
                icon: 'levels/sumas_y_restas.png',
            },

            {
                uid: 3,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'heart',
                        params: { series: [{ init: 1, finish: 999, num: 4 }], couples: 'random', init: 0, finish: 9, rows: 3, valueinabacus: 0, coins: 10, num: 4, errors: 0 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: { couples: ['2+2', '2+5', '2+6', '2+7', '3+5', '3+6', '4+5', '5+2', '5+3', '5+4', '6+2', '6+3', '7+2', '4-2', '4-3', '6-5', '7-2', '7-5', '7-6', '8-2', '8-3', '8-5', '8-6', '8-7', '9-2', '9-3', '9-4', '9-5', '9-6', '9-7', '9-8'], init: 1, finish: 9, rows: 1, valueinabacus: 0, coins: 10, num: 0, errors: 0, levels: [{ num: 2, vel: 20 }, { num: 4, vel: 20 }, { num: 8, vel: 20 }, { num: 6, vel: 10 }, { num: 8, vel: 10 }] }
                    },
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['2+7', '3+6', '4+5', '5+4', '6+1', '6+2', '6+3', '7+1', '7+2', '8+1', '7+2', '1+8', '1+1+2', '1+3+5', '1+5+2', '1+6+1', '2+2+5', '2+6+1', '3+1+5'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0 }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['9-2', '9-4', '9-5', '9-7', '9-8', '8-1', '8-2', '8-3', '8-5', '8-7', '8-6', '7-2', '7-5', '7-6', '6-1', '6-5', '4-1', '4-2', '4-3', '3-1', '3-2', '9-6-1', '9-1-7'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 2: suma y resta 5 **/
    {
        level: 2,
        label: 'wood',
        open: true,
        units: [
            {
                uid: 4,
                label: 'sumswith5',//Sumas con 5
                level: 2,
                icon: 'levels/sumas_5.png',
            },

            {
                uid: 5,
                label: 'subswith5',//Restas 5
                level: 2,
                icon: 'levels/restas_5.png',
            },

            {
                uid: 6,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 2,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['1+4', '2+3', '2+4', '3+2', '3+3', '3+4', '4+1'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: ['5-1', '5-2', '6-2', '5-3', '6-3', '7-3', '5-4', '6-4', '7-4', '8-4'], valueinabacus: 0, rows: 1, coins: 10, num: 5, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 3: suma y resta 10 **/
    {
        level: 3,
        label: 'iron',
        open: true,
        units: [
            {
                uid: 8,
                label: 'sumswith10',
                level: 3,
                icon: 'levels/sumas_10.png',
            },


            {
                uid: 9,
                label: 'subswith10',
                level: 3,
                icon: 'levels/restas_10.png',
            },

            {
                uid: 10,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 3,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'relaciona',
                        params: { couples: 'random', init: 10, finish: 99, rows: 2, valueinabacus: 0, coins: 10, num: 4, errors: 0 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: { couples: ['8+6', '7+7', '7+6', '6+6', '6+7', '6+8', '5+6', '5+7', '5+8', '5+9', '9+3', '9+4', '9+5', '9+6', '9+7', '9+8', '9+9', '8+2', '8+3', '8+4', '8+5', '8+7', '8+8', '8+9', '7+9', '7+3', '7+4', '7+5', '6+9', '6+5', '6+4', '5+5', '4+9', '4+8', '4+7', '4+6', '3+9', '3+8', '3+7', '2+8', '2+9', '1+9', '8+6', '7+7', '7+6', '6+6', '6+7', '6+8', '5+6', '5+7', '5+8', '5+9', '11-6', '12-6', '12-7', '13-6', '13-7', '13-8', '14-6', '14-7', '14-8', '14-9', '10-1', '10-2', '10-3', '10-4', '10-5', '10-6', '10-7', '10-8', '10-9', '11-2', '11-3', '11-4', '11-5', '11-7', '11-8', '11-9', '12-3', '12-4', '12-5', '13-4', '13-5', '13-9', '14-5', '15-6', '15-7', '15-8', '15-9', '16-7', '16-8', '16-9', '17-8', '17-9', '18-9', '11-6', '12-6', '12-7', '13-6', '13-7', '13-8', '14-6', '14-7', '14-8', '14-9'], init: 10, finish: 99, rows: 2, valueinabacus: 0, coins: 10, num: 1, errors: 0, levels: [{ num: 4, vel: 15 }, { num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 10 }, { num: 12, vel: 10 }] }
                    },
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['+'], init: 1, finish: 9, ispan: 1, fspan: 9, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 1, num: 3 }], wait: 3, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['-'], init: 11, finish: 19, ispan: 1, fspan: 9, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 1, num: 3 }], wait: 3, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 4: suma y resta 2c **/
    {
        level: 4,
        label: 'clay',
        open: true,
        units: [

            {
                uid: 12,
                label: 'sumsandsubswith2',
                level: 4,
                icon: 'levels/sumas_y_restas_2_cifras.png',
            },

            {
                uid: 13,
                label: 'strengthenlearnt',//practicar
                level: 4,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'relaciona',
                        params: { couples: 'random', init: 10, finish: 99, rows: 2, valueinabacus: 0, coins: 10, num: 4, errors: 0, style: 'small', 'flipbacktime': 2000 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['-', '+'], 'numops': 2, init: 30, finish: 60, ispan: 11, fspan: 29, rows: 2, valueinabacus: 0, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'pathchall',//El reto del camino,
                        impl: 'pathchall',
                        icon: 'path',
                        params: { couples: 'random', init: 2, finish: 6, op: '+', ispan: 11, fspan: 19, items: 5, num: 2, cols: 6, coins: 10, errors: 0 }
                    },
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['+'], init: 11, finish: 29, ispan: 11, fspan: 29, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 2, num: 3 }, { digits: 1, num: 3 }], wait: 4, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['-'], init: 71, finish: 99, ispan: 11, fspan: 19, valueinabacus: 0, rows: 2, coins: 10, num: 1, config: [{ digits: 2, num: 3 }, { digits: 1, num: 3 }], wait: 4, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 5: suma resta 3c **/
    {
        level: 5,
        label: 'bronze',
        open: true,
        units: [
            {
                uid: 14,
                label: 'sumsandsubswith3',
                level: 5,
                icon: 'levels/sumas_y_restas_3_cifras.png',
            },

            {
                uid: 15,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 5,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'matchchall',//El reto de las parejas,
                        impl: 'memoset',
                        icon: 'heart',
                        params: { couples: 'random', init: 100, finish: 999, rows: 3, valueinabacus: 0, coins: 10, num: 4, errors: 0, style: 'small', 'flipbacktime': 2000 }
                    },
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['-', '+'], 'numops': 2, init: 300, finish: 600, ispan: 111, fspan: 299, rows: 3, valueinabacus: 0, 'upperlimit': 999, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'pathchall',//El reto del camino,
                        impl: 'pathchall',
                        icon: 'path',
                        params: { couples: 'random', init: 20, finish: 60, op: '+', ispan: 101, fspan: 199, num: 2, items: 7, cols: 4, coins: 10, errors: 0 }
                    },
                    {
                        label: 'mentalsumchall',
                        icon: 'mental',
                        impl: 'mentalsumsubstraction',
                        params: { couples: 'random', ops: ['+'], init: 111, finish: 299, ispan: 111, fspan: 199, valueinabacus: 0, rows: 3, coins: 10, num: 1, config: [{ digits: 3, num: 3 }, { digits: 2, num: 2 }, { digits: 1, num: 2 }], wait: 5, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['-'], init: 711, finish: 999, ispan: 111, fspan: 199, valueinabacus: 0, rows: 3, coins: 10, num: 1, config: [{ digits: 3, num: 3 }, { digits: 2, num: 2 }, { digits: 1, num: 2 }], wait: 5, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 6: multiplicaciones 1 c **/
    {
        level: 6,
        label: 'ivory',
        open: true,
        units: [
            {
                uid: 17,
                label: 'multi1',
                level: 7,
                icon: 'levels/multiplicaciones_1_cifra.png',
            },

            {
                uid: 18,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 7,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'challmultI',//Practica con el ábaco,
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['*'], only_answer: true, init: 11, finish: 99, ispan: 2, fspan: 9, rows: 3, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'challmultII',//Practica con el ábaco,
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['*'], only_answer: true, init: 111, finish: 999, ispan: 2, fspan: 9, rows: 4, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'baloonschallI',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['*'], 'numops': 2, init: 11, finish: 99, ispan: 2, fspan: 9, rows: 3, valueinabacus: 0, 'upperlimit': 9 * 99, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }

                    },
                    {
                        label: 'baloonschallII',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['*'], 'numops': 2, init: 111, finish: 999, ispan: 2, fspan: 9, rows: 4, valueinabacus: 0, 'upperlimit': 999 * 9, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                ]
            },
        ],
        
    },

    /**level 7: divisiones 1 c **/
    {
        level: 7,
        label: 'glass',
        open: true,
        units: [
            {
                uid: 19,
                label: 'divi1',
                level: 8,
                icon: 'levels/divisiones_1_cifra.png',
            },

            {
                uid: 20,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 8,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'challdivI',
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['/'], only_answer: true, init: 11, finish: 99, ispan: 2, fspan: 9, rows: 2, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'challdivII',
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['/'], only_answer: true, init: 111, finish: 999, ispan: 2, fspan: 9, rows: 3, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'baloonschallI',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['/'], 'numops': 2, init: 11, finish: 99, ispan: 2, fspan: 9, rows: 2, valueinabacus: 0, 'upperlimit': 99 / 9, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'baloonschallII',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['/'], 'numops': 2, init: 111, finish: 999, ispan: 2, fspan: 9, rows: 3, valueinabacus: 0, 'upperlimit': 999 / 9, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                ]
            },
        ],
        
    },

    /**level 8: suma y resta 4c **/
    {
        level: 8,
        label: 'steel',
        open: true,
        units: [
            {
                uid: 21,
                label: 'sumsandsubswith4',
                level: 6,
                icon: 'levels/sumas_y_restas_4_cifras.png',
            },

            {
                uid: 24,
                label: 'strengthenlearnt',
                level: 6,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'baloonschall',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['-', '+'], 'numops': 2, init: 3000, finish: 6000, ispan: 111, fspan: 2999, rows: 4, valueinabacus: 0, 'upperlimit': 9999, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'pathchall',//El reto del camino,
                        impl: 'pathchall',
                        icon: 'path',
                        params: { couples: 'random', init: 200, finish: 600, op: '+', ispan: 1001, fspan: 1999, num: 2, items: 7, cols: 4, coins: 10, errors: 0 }
                    },
                    {
                        label: 'mentalsumchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['+'], init: 1111, finish: 2999, ispan: 1111, fspan: 1999, valueinabacus: 0, rows: 4, coins: 10, num: 1, config: [{ digits: 4, num: 3 }, { digits: 3, num: 2 }, { digits: 2, num: 2 }], wait: 6, errors: 0, cansubstract: true }
                    },
                    {
                        label: 'mentalsubchall',
                        impl: 'mentalsumsubstraction',
                        icon: 'mental',
                        params: { couples: 'random', ops: ['-'], init: 7111, finish: 9999, ispan: 1111, fspan: 1999, valueinabacus: 0, rows: 4, coins: 10, num: 1, config: [{ digits: 4, num: 3 }, { digits: 3, num: 2 }, { digits: 2, num: 2 }], wait: 6, errors: 0, cansubstract: true }
                    },
                ]
            },
        ],
        
    },

    /**level 9: mult 2c*/
    {
        level: 9,
        label: 'silver',
        open: true,
        units: [
            {
                uid: 25,
                label: 'multi2',
                level: 9,
                icon: 'levels/multiplicaciones_2_cifras.png',
            },

            {
                uid: 26,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 9,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'challmultI',
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['*'], only_answer: true, init: 11, finish: 99, ispan: 11, fspan: 99, rows: 4, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'challmultII',
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['*'], only_answer: true, init: 111, finish: 999, ispan: 11, fspan: 99, rows: 5, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'baloonschallI',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['*'], 'numops': 2, init: 11, finish: 99, ispan: 11, fspan: 99, rows: 4, valueinabacus: 0, 'upperlimit': 99 * 99, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'baloonschallII',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['*'], 'numops': 2, init: 111, finish: 999, ispan: 11, fspan: 99, rows: 5, valueinabacus: 0, 'upperlimit': 999 * 99, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                ]
            },
        ],
        
    },

    /**level 10: div 2c*/
    {
        level: 10,
        label: 'gold',
        open: true,
        units: [
            {
                uid: 27,
                label: 'divi2',
                level: 10,
                icon: 'levels/divisiones_2_cifras.png',
            },

            {
                uid: 28,
                label: 'strengthenlearnt',//Sumar y restar con el 5,
                level: 10,
                icon: 'levels/juega.png',
                exercises: [
                    {
                        label: 'challdivI',
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['/'], only_answer: true, init: 111, finish: 999, ispan: 11, fspan: 99, rows: 2, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'challdivII',
                        impl: 'multiplydivide',
                        icon: 'reto',
                        params: { couples: 'random', ops: ['/'], only_answer: true, init: 1111, finish: 9999, ispan: 11, fspan: 99, rows: 3, coins: 10, num: 5, errors: 1, cansubstract: true, markers: false, onlyanswer: true }
                    },
                    {
                        label: 'baloonschallI',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['/'], 'numops': 2, init: 111, finish: 999, ispan: 11, fspan: 99, rows: 2, valueinabacus: 0, 'upperlimit': 99 / 9, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                    {
                        label: 'baloonschallII',//El reto de los globos,
                        impl: 'baloonschall',
                        icon: 'globo',
                        params: {
                            couples: 'random', ops: ['/'], 'numops': 2, init: 1111, finish: 9999, ispan: 11, fspan: 99, rows: 3, valueinabacus: 0, 'upperlimit': 9999 / 9, coins: 10, num: 1, errors: 0,
                            levels: [{ num: 6, vel: 15 }, { num: 8, vel: 15 }, { num: 10, vel: 15 }, { num: 12, vel: 10 }, { num: 14, vel: 10 }]
                        }
                    },
                ]
            },
        ],
        
    },

    /**challenges **/
    {
        level: 'challenges',
        label: 'iron',
        open: true,
        units: [
            {
                uid: 'ch1',
                label: 'strengthenlearnt',
                level: 1,
                icon: 'challenge/numriddle.png',
                exercises: [
                    {
                        label: 'findvalue',
                        impl: 'numberriddle',
                        icon: 'easys',
                        params: { coins: 20, num: 1, errors: 0, timeout: 30, init: 2, finish: 11 }
                    },
                    {
                        label: 'completeoperations',
                        impl: 'completeoperations',
                        icon: 'easys',
                        params: { ops: 2, coins: 20, num: 1, errors: 0, timeout: 30 }
                    },
                    {
                        label: 'challengevisualmem',
                        impl: 'memomeshchallenge',
                        icon: 'easys',
                        params: { num_objects: 6, init: 21, finish: 199, wait: 10, coins: 40, num: 1, errors: 0, timeout: 60, rows: 3 }
                    },
                    {
                        label: 'findpath',
                        impl: 'numericpath',
                        icon: 'easys',
                        params: { ispan: 1, fspan: 59, num: 1, items: 7, cols: 4, timeout: 120, rows: 3, coins: 50, errors: 0 }
                    },
                    {
                        label: 'solveequation',
                        impl: 'equationchallenge',
                        icon: 'easys',
                        params: { ops: 5, init: 21, finish: 119, num: 1, timeout: 30, rows: 3, coins: 60, errors: 0 }
                    },
                ]
            },
            

        ],
    }
];


const competition = {
    1: competition1,
    2: competition2,
    3: competition3,
}

export default competition;